import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const config = {
  projectId: "words-1525173481367",
  apiKey: "AIzaSyDFX0ZsOww2-lTuiGgeg5FxPWstUkdeuDg",
  authDomain: "words-1525173481367.firebaseapp.com",
  databaseURL: "words-1525173481367.firebaseio.com"
};

firebase.initializeApp(config);

const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);

const auth = firebase.auth();

export { firebase as default, firestore, auth };



// WEBPACK FOOTER //
// ./src/helpers/Firebase.js